<ul class="navbar-nav">
  @if (outerWidth >= 992) {
    @for (category of categories; track $index) {
      <li
        class="nav-item"
        appMouseover
        [mouseoverDelay]="timeOutTime"
        cssClass="open"
        [cssClassCleanup]="true"
        (mouseoverDelayed)="onSubMenuOpen(category)"
        routerLinkActive="active"
      >
        @if (category.url_path !== 'brandid') {
          <a
            sRouterLink="category/{{ category.url_path }}"
            (click)="closeMenu($event)"
            class="nav-link"
          >
            {{ category.name | translate | async }}
          </a>
        }
        @if (category.url_path === 'brandid') {
          <a (click)="closeMenu($event)" class="nav-link">
            {{ category.name | translate | async }}
          </a>
        }

        @if (category.open) {
          <ng-container
            [ngTemplateOutlet]="subNavTemplate"
            [ngTemplateOutletContext]="{ category: category }"
          >
          </ng-container>
        }
      </li>
    }
  }
  @if (outerWidth < 992) {
    @for (category of categories; track $index) {
      <li
        class="nav-item"
        [ngClass]="{ 'mob-open': category.mobileOpen }"
        routerLinkActive="active"
        (mouseenter)="hoverMenuItem($event)"
        (mouseleave)="blurMenuItem($event)"
      >
        @if (category.sub_categories) {
          <button
            class="nav-link btn-block"
            (click)="category.mobileOpen = !category.mobileOpen"
          >
            <span translate>{{ category.name }}</span>
            <mat-icon>arrow_forward_ios</mat-icon>
          </button>
        }
        <ng-container
          [ngTemplateOutlet]="subNavTemplate"
          [ngTemplateOutletContext]="{ category: category }"
        >
        </ng-container>
      </li>
    }
  }
</ul>

<ng-template #subNavTemplate let-category="category">
  <div class="sub-nav" [ngClass]="{ brands: category.url_path === 'brandid' }">
    <button class="btn-close" (click)="backAction(category, $event)">
      <mat-icon>arrow_back_ios</mat-icon>
      <span class="text" translate>Back</span>
    </button>
    <div class="sub-nav__container container">
      <div class="sub-nav__container-left">
        <ul class="sub-nav__categories">
          <li class="sub-nav__view-all">
            <a sRouterLink="category/{{ category.url_path }}" (click)="toggleMenu()">
              <span translate>View All</span>
            </a>
          </li>
          @if (category.sub_categories?.length) {
            @for (subCategory of category.sub_categories; track $index) {
              @if (only3Level(subCategory)) {
                <li>
                  <a
                    class="sub-nav__category"
                    sRouterLink="category/{{ subCategory.url_path }}"
                    (click)="closeMenu($event)"
                  >
                    @if (subCategory.image) {
                      <img
                        class="sub-nav__category-image"
                        [src]="getCategoryImage(subCategory.image)"
                        alt="subCategory.name"
                      />
                    } @else {
                      <mat-icon>settings</mat-icon>
                    }
                    <span class="nav__category-name">{{ subCategory.name }}</span>
                  </a>
                </li>
              }
            }
          }
        </ul>
      </div>
      <div class="sub-nav__container-right">
        @if (isBlogItemsShow) {
          <div class="block-title">
            <span class="block-title__text" translate>Stay up to date</span>
          </div>
          @for (item of currentBlogItems; track $index) {
            <div class="blog-items-wrap" [innerHTML]="item.content"></div>
          }
        } @else {
          @if (category.image) {
            <img
              loading="lazy"
              class="sub-nav__category-main-image"
              [src]="categoryImageUrl(category.image)"
              [alt]="category.name"
            />
          }
        }
      </div>
    </div>
  </div>
</ng-template>

<div class="nav-overlay"></div>
